// ATF WebWorks — AI Transparency Standard badge.
// Shows the provenance of any AI-assisted artifact consistently platform-wide.
// mode: "live" | "fallback" | "manual"  (accepts legacy boolean `connected`).

const MODES = {
  live: { label: "AI Drafted · Live GPT", cls: "bg-green-500/10 text-green-300 border-green-500/30", dot: "bg-green-400" },
  fallback: { label: "Auto Generated · Offline Engine", cls: "bg-amber-500/10 text-amber-300 border-amber-500/30", dot: "bg-amber-400" },
  manual: { label: "Created Manually", cls: "bg-white/5 text-gray-300 border-white/20", dot: "bg-gray-400" },
};

export function AiSourceBadge({ mode, connected, label, size = "sm", className = "" }) {
  const key = mode || (connected === true ? "live" : connected === false ? "fallback" : "manual");
  const m = MODES[key] || MODES.manual;
  const pad = size === "xs" ? "text-[10px] px-1.5 py-0.5" : "text-[11px] px-2 py-1";
  return (
    <span data-testid="ai-source-badge" data-ai-mode={key}
      className={`inline-flex items-center gap-1.5 font-medium rounded-full border ${pad} ${m.cls} ${className}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${m.dot}`} />
      {label || m.label}
    </span>
  );
}

export const aiModeLabel = (mode) => (MODES[mode] || MODES.manual).label;
